/**
 * Parse backend upload size strings (e.g. "10MB", "1G", "10GB") to bytes.
 * Uses binary prefixes (1024) to match humanFileSize and file.size.
 */
export function parseUploadSizeToBytes(value: unknown): number | undefined {
  const normalized = String(value ?? "")
    .trim()
    .replace(",", ".");
  if (!normalized) {
    return undefined;
  }

  const match = normalized.match(/^([\d.]+)\s*(K|M|G|T)?B?$/i);
  if (!match) {
    return undefined;
  }

  const amount = parseFloat(match[1]);
  if (!Number.isFinite(amount) || amount < 0) {
    return undefined;
  }

  const unit = (match[2] || "B").toUpperCase();
  const multipliers: Record<string, number> = {
    B: 1,
    K: 1024,
    M: 1024 ** 2,
    G: 1024 ** 3,
    T: 1024 ** 4,
  };

  return amount * multipliers[unit];
}

/** Bytes over the configured max (0 if within limit). */
export function getUploadSizeOverageBytes(
  totalBytes: number,
  maxSize: unknown,
): number {
  const maxBytes = parseUploadSizeToBytes(maxSize);
  if (!maxBytes) {
    return 0;
  }
  return Math.max(0, totalBytes - maxBytes);
}

/** Strict byte comparison — matches backend / Tomcat limits. */
export function exceedsUploadSizeLimit(
  totalBytes: number,
  maxSize: unknown,
): boolean {
  return getUploadSizeOverageBytes(totalBytes, maxSize) > 0;
}
